const formatCurrency = (number, includeSpace = true, symbol = 'R') => {
  return (symbol ?? '') + (includeSpace ? ' ' : '') + number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const formatNumbers = (number) => {
  return number.toLocaleString();
};

export const useString = () => {
  return {
    formatCurrency,
    formatNumbers,
  };
};
